import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { allRequestsNotStarted, allRequestsHaveCompleted } from "@ane/core/lib/models";
import ExperimentationGroupSettingsResource from "../../../resources/expapiunified/ExperimentationGroupSettings.resource.js";
import "./endpoints/index.js";
import { selectGetSettingsForEgAsyncRequest } from "./endpoints/experimentation-group-settings.js";
const useAuthoringApiSelector = (workspaceId, selector) => useSelector((state) => selector(state.api.authoring[workspaceId]));
const useAuthoringApiSelectEgSettingsResult = (workspaceId, experimentationGroup) => useSelector(
  (state) => selectGetSettingsForEgAsyncRequest(
    state.api.authoring[ExperimentationGroupSettingsResource.getWorkspaceEgPath(workspaceId, experimentationGroup)],
    experimentationGroup
  )
);
const useEffectIfAllNotStarted = (action, statuses, extraConditions = []) => {
  const [hasRun, setHasRun] = useState(false);
  useEffect(() => {
    if (!hasRun && !extraConditions.some((c) => !c) && allRequestsNotStarted(statuses)) {
      action();
      setHasRun(true);
    }
  }, [...statuses, hasRun, ...extraConditions, action]);
  return () => setHasRun(false);
};
const useEffectAfterAllCompleted = (action, statuses, extraConditions = []) => {
  const [hasRun, setHasRun] = useState(false);
  useEffect(() => {
    if (!hasRun && !extraConditions.some((c) => !c) && allRequestsHaveCompleted(statuses)) {
      action();
      setHasRun(true);
    }
  }, [...statuses, hasRun, ...extraConditions]);
  return () => setHasRun(false);
};
export {
  useAuthoringApiSelectEgSettingsResult,
  useAuthoringApiSelector,
  useEffectAfterAllCompleted,
  useEffectIfAllNotStarted
};
//# sourceMappingURL=hooks.js.map
